/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const e=()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches;export{e as prefersReducedMotion};
